import { DatePicker } from "../ui/DatePicker";
import { useIsMobile } from "../ui/useIsMobile";

export function Toolbar({
  date,
  onDate,
  editor,
  onEditor,
}: {
  date: string;
  onDate: (d: string) => void;
  editor: string;
  onEditor: (v: string) => void;
}) {
  const isMobile = useIsMobile();
  return (
    <div
      style={{
        position: "sticky", top: 0, zIndex: 20,
        background: "color-mix(in srgb, var(--bg-app) 88%, transparent)",
        backdropFilter: "blur(8px)", borderBottom: "1px solid var(--border)",
        padding: "12px 0", marginBottom: "20px",
      }}
    >
      <div style={{ display: "flex", alignItems: isMobile ? "stretch" : "center", gap: isMobile ? "10px" : "12px", flexWrap: "wrap", flexDirection: isMobile ? "column" : "row" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <img src="/assets/logo-mark.svg" alt="" height={30} />
          <span style={{ fontFamily: "var(--font-serif)", fontWeight: 600, fontSize: "var(--text-md)", color: "var(--text-primary)" }}>
            Animation de messe
          </span>
        </div>

        {!isMobile && <div style={{ flex: 1 }} />}

        <input
          type="text"
          value={editor}
          onChange={(e) => onEditor(e.target.value)}
          placeholder="Votre prénom"
          aria-label="Votre prénom (pour identifier vos modifications)"
          title="Votre prénom — pour identifier vos modifications auprès de l'équipe"
          style={{
            width: isMobile ? "100%" : 120, boxSizing: "border-box", font: "inherit", fontSize: "var(--text-sm)", padding: "7px 11px",
            border: "1px solid var(--border-strong)", borderRadius: "var(--radius-md)",
            background: "var(--bg-raised)", color: "var(--text-primary)", outline: "none",
          }}
        />

        <DatePicker value={date} onChange={onDate} highlightWeekday={0} compact={!isMobile} fullWidth={isMobile} />
      </div>
    </div>
  );
}
